import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navHeight: 60,
    botnavHeight: 80,
    newsClass: 7,
    contFlag: false
  },
  mutations: {
    update_navHeight (state, val) {
      state.navHeight = val
    },
    update_botnavHeight (state, val) {
      state.botnavHeight = val
    },
    update_newsClass (state, val) {
      state.newsClass = val
    },
    setStatus_contFlag (state) {
      state.contFlag = !state.contFlag
    }
  },
  actions: {
  },
  modules: {
  }
})
